export default "__VITE_ASSET__2ac96f44__"